import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Loader2, Printer, Gift } from "lucide-react";
import api from "../lib/api";

const GiftCardSuccess = () => {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState({ status: "checking", card: null });

  useEffect(() => {
    if (!sessionId) { setState({ status: "error" }); return; }
    let tries = 0;
    let timer;
    const poll = async () => {
      tries += 1;
      try {
        const { data } = await api.get(`/giftcards/status/${sessionId}`);
        if (data.payment_status === "paid" && data.code) {
          setState({ status: "done", card: data });
          return;
        }
      } catch (e) { /* keep polling */ }
      if (tries < 8) timer = setTimeout(poll, 2000);
      else setState({ status: "pending" });
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId]);

  return (
    <main className="max-w-2xl mx-auto px-5 py-12 text-center" data-testid="giftcard-success-page">
      {state.status === "checking" && (
        <div className="py-20"><Loader2 className="animate-spin mx-auto" size={40} /><p className="mt-4 text-[#333]">Confirming your payment and creating your gift card…</p></div>
      )}
      {state.status === "pending" && (
        <div className="py-20"><p className="text-[#333]">Your payment is processing. Your gift card and code will be emailed to you shortly.</p></div>
      )}
      {state.status === "error" && (
        <div className="py-20"><p className="text-[#EC008C] font-bold">We couldn't find that gift card session.</p></div>
      )}
      {state.status === "done" && state.card && (
        <div>
          <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-[#EC008C]"><Gift size={14} /> Gift Card Ready</div>
          <h1 className="font-display font-black text-3xl md:text-4xl text-black mt-2">Thank you!</h1>
          <p className="mt-2 text-[#333]">We've emailed this card to {state.card.buyer_email}. Print this page to gift it.</p>

          <div id="printable-card" className="mt-8 mx-auto max-w-md rounded-3xl overflow-hidden border-4 border-black brutal-lg bg-[#14141B] text-white">
            <div className="bg-[#EC008C] px-6 py-4 font-black tracking-widest">MAKEBA DESIGN & PRINTS</div>
            <div className="px-6 py-10">
              <div className="text-xs tracking-[0.3em] uppercase text-[#F4D160]">Gift Card</div>
              <div className="text-6xl font-black my-3" data-testid="giftcard-amount">${Number(state.card.amount).toFixed(2)}</div>
              <div className="text-xs text-white/60">Redeemable at makebadesigns.com</div>
              <div className="mt-6 mx-auto max-w-xs bg-[#1E1E29] border border-dashed border-[#EC008C] rounded-xl py-4">
                <div className="text-[10px] tracking-widest uppercase text-white/50">Gift Code</div>
                <div className="text-2xl font-black tracking-[0.2em] text-[#F4D160] font-mono" data-testid="giftcard-code">{state.card.code}</div>
              </div>
            </div>
          </div>

          <button onClick={() => window.print()} className="mt-6 inline-flex items-center gap-2 bg-black text-white font-black px-6 py-3 rounded-full brutal" data-testid="giftcard-print-btn">
            <Printer size={16} /> Print gift card
          </button>
        </div>
      )}
    </main>
  );
};

export default GiftCardSuccess;
